class restoreTemplate {
    constructor($injector) {
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');

        this.key = 'restore-template';
        this.title = this.translate.instant('templates.workflows.details.restore-template.title');
        this.level = 'archived-highlight';
        this.icon = 'fal fa-undo';
    }

    /**
     * @todo translate and rework
     * @param template
     * @param vm
     */
    action(template, vm) {
        this.alert.confirm({
            title: `Restoring ${ template.name}`,
            message: 'Are you sure you want to restore this template? This cannot be undone!',
            confirmBtn: 'Restore'
        }).then(() => {
            return this.api.put(`templates/${ template.id }/restore`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('restoreTemplate', [
        '$injector',
        ($injector) => new restoreTemplate($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/restore-template.js